import clientConfigurationProvider from "../../providers/clientConfigurationProvider";

export default () => {
  const { recommendationsRetriesBackoff: retryBackoffs } =
    clientConfigurationProvider();

  return retryCount => retryBackoffs[retryCount - 1];
};
